<template>
    <div>
        <field-name :recipientInfo="recipientInfo"></field-name>
        <field-sort-code :recipientInfo="recipientInfo"></field-sort-code>
        <field-account-number :recipientInfo="recipientInfo"></field-account-number>
    </div>
</template>

<script>

    import fieldName from './match-confirmed-reveal-field-name';
    import fieldSortCode from './match-confirmed-reveal-field-sort-code';
    import fieldAccountNumber from './match-confirmed-reveal-field-account-number';

    export default {
        name: "match-confirmed-reveal-faster-payment",
        props: {
            recipientInfo: Object
        },
        components: {
           fieldName,
           fieldSortCode,
           fieldAccountNumber,
        },
    };
</script>
